module.exports = __webpack_public_path__ + "static/media/happiness_widget_background.abe83afa.png";